
import axios from '../plugins/axiosPlugins'

import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().api2BaseUrl;

/**
 * 获取确权视频的列表
 * @returns
 */
export const getByCode = (code:string) => {
    return axios.get(`${baseURL}/user/Appsettings/${code}`);
}